import {
  MODAL_BLOCK,
  MODAL_BLOCK_CONTENT_VIEW,
} from '@components/App/Modal/constants'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { migrationUiSelector } from '@store/migrationSelectors/uiSelectors'
import type { AppState } from '@store/types'
import { useSelector } from 'react-redux'

import { usePrintRender } from '@/hooks'

export const useHeader = () => {
  const readOnly = useSelector(
    migrationProjectSelector.getProjectLegacyAccessTypeIsReadOnly
  )
  const canEdit = useSelector(migrationProjectSelector.getProjectAccessCanEdit)
  const canEditContent = useSelector(
    migrationProjectSelector.getProjectAccessCanEditContent
  )
  const projectId = useSelector(migrationProjectSelector.getProjectId)

  const trial = useSelector(migrationProjectSelector.getProjectIsTrial)

  const template = useSelector(migrationProjectSelector.getProjectIsTemplate)

  const isEmbed = useSelector<AppState, boolean>(
    ({ artboard }) => artboard.isEmbed
  )

  const modalType = useSelector(migrationUiSelector.getModalType)

  const { isPrinting } = usePrintRender()

  const pageContentModal = [MODAL_BLOCK, MODAL_BLOCK_CONTENT_VIEW].includes(
    modalType
  )

  const copywriterMode = !canEdit && canEditContent && !isEmbed

  return {
    readOnly,
    copywriterMode,
    projectId,
    trial,
    template,
    isEmbed,
    isPrinting,
    pageContentModal,
  }
}
